import { atom } from "jotai";
import { type DecodeResult, decode } from "@/modules/plus/decoder/plus.decoder";
import type { AtomContainer } from "@/state";

const MAX_RECENT = 8;

// Single search box on `/` drives both the decoder breakdown card and the
// filtered models list. Both pull from the canonical Firestore-backed data.
export class SearchAtoms {
  constructor(private readonly atoms: AtomContainer) {}

  public text = atom<string>("");

  public decoded = atom<DecodeResult>((get) => {
    const templates = get(this.atoms.data.templates);
    const models = get(this.atoms.data.models);
    return decode(get(this.text), templates, models);
  });

  public hasDecodedResult = atom<boolean>((get) => get(this.decoded).ok);

  public recent = atom<string[]>([]);

  public recordRecent = atom(null, (get, set, code: string) => {
    const normalized = code.trim();
    if (!normalized) {
      return;
    }
    const prev = get(this.recent).filter((c) => c !== normalized);
    set(this.recent, [normalized, ...prev].slice(0, MAX_RECENT));
  });
}
